import { render } from "./GanttChart.vue?vue&type=template&id=400377f7"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=400377f7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__